import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import Appointment from "./Appointment";
import KitDetails from "./KitDetails";
import PatientHistory from "./History";
import HealthStatus from "./HealthStatus";
import PatientMessage from "./PatientMessage";
import ChartingNotes from "./ChartingNotes";
import Prescription from "./Prescription";
import Sidebar from "./Sidebar";

export const TABS = {
  APPOINTMENT: "Appointment",
  KIT_DETAIL: "Kit Detail",
  HISTORY: "History",
  HEALTH_STATUS: "Health Status",
  MESSAGE: "Message",
  CHARTING_NOTES: "Charting Notes",
  PRESCRIPTION: "Prescriptions"
};

export default function PatientDashboard({ patientId, patientDetail }) {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(TABS.APPOINTMENT);
  const [viewId, setViewId] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const viewParamRaw = queryParams.get("view");
    const idParamRaw = queryParams.get("viewId");

    const viewParam = typeof viewParamRaw === "string" ? viewParamRaw.trim().toLowerCase() : "";
    const idParam = typeof idParamRaw === "string" && idParamRaw.trim() !== "" ? idParamRaw.trim() : null;

    if (idParam) setViewId(idParam);

    if (viewParam) {
      const matchedTab = Object.entries(TABS).find(
        ([, value]) =>
          value.toLowerCase().replace(/\s+/g, "-") === viewParam
      );
      if (matchedTab) {
        setActiveTab(matchedTab[1]);
      }
    }
  }, [location.search]);

  return (
    <div className="patientDashboard">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === TABS.APPOINTMENT && patientDetail && patientDetail.email ? (
        <Appointment
          patientId={patientId}
          patientEmail={patientDetail.email}
          patientDetail={patientDetail}
          viewId={typeof viewId === "string" ? viewId : null}
        />
      ) : activeTab === TABS.APPOINTMENT ? (
        <div>Loading appointment details...</div>
      ) : null}

      {activeTab === TABS.KIT_DETAIL ? (
        <KitDetails patientId={patientId} patientEmail={patientDetail.email} viewId={typeof viewId === "string" ? viewId : null} />
      ) : null}

      {activeTab === TABS.HISTORY && patientDetail && patientDetail.email ? (
        <PatientHistory
          patientId={patientId}
          patientEmail={patientDetail.email}
          viewId={typeof viewId === "string" ? viewId : null}
        />
      ) : activeTab === TABS.HISTORY ? (
        <div>Loading patient history...</div>
      ) : null}

      {activeTab === TABS.HEALTH_STATUS && patientDetail ? (
        <HealthStatus
          patientId={patientId}
          patientDetail={patientDetail}
          viewId={typeof viewId === "string" ? viewId : null}
        />
      ) : activeTab === TABS.HEALTH_STATUS ? (
        <div>Loading health status...</div>
      ) : null}

      {activeTab === TABS.MESSAGE ? (
        <PatientMessage patientId={patientId} viewId={typeof viewId === "string" ? viewId : null} />
      ) : null}

      {activeTab === TABS.CHARTING_NOTES && patientDetail ? (
        <ChartingNotes
          patientId={patientId}
          patientDetail={patientDetail}
          viewId={typeof viewId === "string" ? viewId : null}
        />
      ) : activeTab === TABS.CHARTING_NOTES ? (
        <div>Loading charting notes...</div>
      ) : null}

      {activeTab === TABS.PRESCRIPTION && patientDetail && patientDetail.email ? (
        <Prescription
          patientId={patientId}
          patientEmail={patientDetail.email}
          patientDetail={patientDetail}
          viewId={typeof viewId === "string" ? viewId : null}
        />
      ) : activeTab === TABS.PRESCRIPTION ? (
        <div>Loading prescriptions...</div>
      ) : null}
    </div>
  );
}
